<template>
  <div class="container bnp-bill" :class="'bnp-bill--t' + inx" dir="rtl">
    <panel
      Title="پرداخت قبوض"
      Des="نوع قبض را انتخاب کنید، حساب برداشت را تایید کنید و پس از استعلام، قبض را پرداخت نمایید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>

    <section class="bnp-bill-types" aria-label="انتخاب نوع قبض">
      <ghabz @indexSelected="openGhabz" :indexActive="inx"></ghabz>
    </section>

    <div class="bnp-bill-steps">
      <!-- مرحله ۱: انتخاب حساب -->
      <section class="bnp-bill-card">
        <header class="bnp-bill-card__header">
          <span class="bnp-bill-card__icon" aria-hidden="true"><i class="fas fa-wallet"></i></span>
          <div class="bnp-bill-card__heading">
            <span class="bnp-bill-card__step">مرحله ۱</span>
            <h2 class="bnp-bill-card__title">انتخاب حساب</h2>
          </div>
        </header>
        <div class="bnp-bill-card__body">
          <label for="bnpBillAccount" class="bnp-bill-label">حساب مورد نظر جهت کسر مبلغ قبض را انتخاب نمایید</label>
          <select id="bnpBillAccount" class="form-control bnp-bill-select Pointer" v-model="Taahodat">
            <option :value="item" v-for="(item, key) in listTaahodat" :key="key">{{ item.vcodeDesNo }}</option>
          </select>

          <div class="bnp-bill-balance" v-if="Taahodat && Taahodat.id">
            <div class="bnp-bill-balance__row">
              <span class="bnp-bill-balance__label"><i class="fas fa-coins" aria-hidden="true"></i> موجودی قابل برداشت</span>
              <strong class="bnp-bill-balance__value">{{ $Comma3ragham(Taahodat.ghabelBardasht) }} <small>ریال</small></strong>
            </div>
            <button v-if="inx == 0 || inx == 1 || inx == 2 || inx == 3 || inx == 4" type="button" class="bnp-bill-btn" @click="taahodatId = Taahodat.bnpCashDBtblTaahodatId">
              <i class="fas fa-check-circle" aria-hidden="true"></i>
              انتخاب و تایید حساب
            </button>
            <p v-if="taahodatId != null && taahodatId == Taahodat.bnpCashDBtblTaahodatId" class="bnp-bill-hint bnp-bill-hint--success">
              <i class="fas fa-check" aria-hidden="true"></i>
              این حساب برای پرداخت قبض تایید شده است
            </p>
          </div>
          <p v-else class="bnp-bill-hint">
            <i class="fas fa-info-circle" aria-hidden="true"></i>
            پس از انتخاب حساب، موجودی قابل برداشت آن نمایش داده می‌شود
          </p>
        </div>
      </section>

      <!-- مرحله ۲: استعلام (در انتظار) -->
      <section class="bnp-bill-card bnp-bill-card--placeholder" v-if="taahodatId == null">
        <div class="bnp-bill-empty">
          <span class="bnp-bill-empty__icon" aria-hidden="true"><i class="fas fa-search-dollar"></i></span>
          <span class="bnp-bill-card__step">مرحله ۲</span>
          <h2 class="bnp-bill-card__title">استعلام قبض</h2>
          <p class="bnp-bill-empty__text">ابتدا حساب برداشت را انتخاب و تایید کنید.</p>
        </div>
      </section>

      <!-- مرحله ۲: استعلام -->
      <div class="bnp-bill-step" v-if="taahodatId != null">
        <!-- آب -->
        <section class="bnp-bill-card" v-if="inx == 0" id="Water">
          <header class="bnp-bill-card__header">
            <span class="bnp-bill-card__icon bnp-bill-card__icon--type" aria-hidden="true"><i class="fas fa-faucet"></i></span>
            <div class="bnp-bill-card__heading">
              <span class="bnp-bill-card__step">مرحله ۲</span>
              <h2 class="bnp-bill-card__title">شناسه قبض آب را وارد نمایید</h2>
            </div>
          </header>
          <div class="bnp-bill-card__body">
            <label for="bnpBillWater" class="bnp-bill-label">برای استعلام، شناسه قبض آب را وارد کنید</label>
            <input id="bnpBillWater" class="form-control bnp-bill-input required" type="number" inputmode="numeric" dir="ltr" v-model="waterBillId" />
            <button type="button" class="bnp-bill-btn" @click="Inquiry_Water">
              <i class="fas fa-search" aria-hidden="true"></i>
              استعلام جزئیات قبض آب
            </button>

            <div class="bnp-bill-saved" v-if="listSave && listSave.length">
              <div class="bnp-bill-saved__title"><i class="fas fa-history" aria-hidden="true"></i> قبوض ذخیره‌شده</div>
              <div class="bnp-bill-saved__item Pointer" v-for="(item, key) in listSave" :key="key" @click="waterBillId = item.billId">
                <div class="bnp-bill-saved__content" :key="Render">
                  <span class="bnp-bill-saved__icon" aria-hidden="true"><i class="fas fa-faucet"></i></span>
                  <div class="bnp-bill-saved__text">
                    <span class="bnp-bill-saved__name">قبض آب <small v-if="item.fullName">{{ item.fullName }}</small></span>
                    <span class="bnp-bill-saved__code" dir="ltr">{{ item.participateCode == null ? item.billId : item.participateCode }}</span>
                  </div>
                  <button type="button" class="bnp-bill-saved__delete" title="حذف" aria-label="حذف قبض ذخیره‌شده" @click="deleteSave(item)"><i class="fas fa-trash-alt" aria-hidden="true"></i></button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- برق -->
        <section class="bnp-bill-card" v-if="inx == 1" id="Electrici">
          <header class="bnp-bill-card__header">
            <span class="bnp-bill-card__icon bnp-bill-card__icon--type" aria-hidden="true"><i class="fas fa-bolt"></i></span>
            <div class="bnp-bill-card__heading">
              <span class="bnp-bill-card__step">مرحله ۲</span>
              <h2 class="bnp-bill-card__title">شناسه قبض برق را وارد نمایید</h2>
            </div>
          </header>
          <div class="bnp-bill-card__body">
            <label for="bnpBillElectricity" class="bnp-bill-label">برای استعلام، شناسه قبض برق را وارد کنید</label>
            <input id="bnpBillElectricity" class="form-control bnp-bill-input required" type="number" inputmode="numeric" dir="ltr" v-model="electricityBillId" />
            <button type="button" class="bnp-bill-btn" @click="Inquiry_Electricity">
              <i class="fas fa-search" aria-hidden="true"></i>
              استعلام جزئیات قبض برق
            </button>

            <div class="bnp-bill-saved" v-if="listSave && listSave.length">
              <div class="bnp-bill-saved__title"><i class="fas fa-history" aria-hidden="true"></i> قبوض ذخیره‌شده</div>
              <div class="bnp-bill-saved__item Pointer" v-for="(item, key) in listSave" :key="key" @click="electricityBillId = item.billId">
                <div class="bnp-bill-saved__content" :key="Render">
                  <span class="bnp-bill-saved__icon" aria-hidden="true"><i class="fas fa-bolt"></i></span>
                  <div class="bnp-bill-saved__text">
                    <span class="bnp-bill-saved__name">قبض برق <small v-if="item.fullName">{{ item.fullName }}</small></span>
                    <span class="bnp-bill-saved__code" dir="ltr">{{ item.participateCode == null ? item.billId : item.participateCode }}</span>
                  </div>
                  <button type="button" class="bnp-bill-saved__delete" title="حذف" aria-label="حذف قبض ذخیره‌شده" @click="deleteSave(item)"><i class="fas fa-trash-alt" aria-hidden="true"></i></button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- گاز -->
        <section class="bnp-bill-card" v-if="inx == 2" id="Gas">
          <header class="bnp-bill-card__header">
            <span class="bnp-bill-card__icon bnp-bill-card__icon--type" aria-hidden="true"><i class="fas fa-fire-alt"></i></span>
            <div class="bnp-bill-card__heading">
              <span class="bnp-bill-card__step">مرحله ۲</span>
              <h2 class="bnp-bill-card__title">مشاهده و پرداخت قبض گاز</h2>
            </div>
          </header>
          <div class="bnp-bill-card__body">
            <span class="bnp-bill-label">روش استعلام را انتخاب کنید</span>
            <label class="bnp-bill-toggle Pointer" for="Done">
              <input type="checkbox" class="bnp-bill-sr-only required InputText Pointer" id="Done" v-model="isBillGas" />
              <span class="bnp-bill-toggle__option" :class="{ 'is-active': isBillGas == false }">شماره اشتراک</span>
              <span id="LbltblComboGrpId50" class="bnp-bill-toggle__option" :class="{ 'is-active': isBillGas == true }">شناسه قبض</span>
            </label>

            <label v-if="isBillGas == false" for="bnpBillGasParticipate" class="bnp-bill-label">شماره اشتراک را وارد کنید</label>
            <label v-if="isBillGas == true" for="bnpBillGasBill" class="bnp-bill-label">شناسه قبض گاز را وارد کنید</label>
            <input id="bnpBillGasParticipate" class="form-control bnp-bill-input required" type="number" inputmode="numeric" dir="ltr" placeholder="شماره اشتراک" v-model="gasParticipateCode" v-if="isBillGas == false" />
            <input id="bnpBillGasBill" class="form-control bnp-bill-input required" type="number" inputmode="numeric" dir="ltr" placeholder="شناسه قبض" v-model="gasBillId" v-if="isBillGas == true" />
            <button type="button" class="bnp-bill-btn" @click="Inquiry_Gas">
              <i class="fas fa-search" aria-hidden="true"></i>
              استعلام جزئیات قبض گاز
            </button>

            <div class="bnp-bill-saved" v-if="listSave && listSave.length">
              <div class="bnp-bill-saved__title"><i class="fas fa-history" aria-hidden="true"></i> قبوض ذخیره‌شده</div>
              <div class="bnp-bill-saved__item Pointer" v-for="(item, key) in listSave" :key="key" @click="replaceGasSaved(item)">
                <div class="bnp-bill-saved__content" :key="Render">
                  <span class="bnp-bill-saved__icon" aria-hidden="true"><i class="fas fa-fire-alt"></i></span>
                  <div class="bnp-bill-saved__text">
                    <span class="bnp-bill-saved__name">قبض گاز <small v-if="item.fullName">{{ item.fullName }}</small></span>
                    <span class="bnp-bill-saved__code" dir="ltr">{{ item.participateCode == null ? item.billId : item.participateCode }}</span>
                  </div>
                  <button type="button" class="bnp-bill-saved__delete" title="حذف" aria-label="حذف قبض ذخیره‌شده" @click="deleteSave(item)"><i class="fas fa-trash-alt" aria-hidden="true"></i></button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- همراه -->
        <section class="bnp-bill-card" v-if="inx == 3" id="Mobile">
          <header class="bnp-bill-card__header">
            <span class="bnp-bill-card__icon bnp-bill-card__icon--type" aria-hidden="true"><i class="fas fa-mobile-alt"></i></span>
            <div class="bnp-bill-card__heading">
              <span class="bnp-bill-card__step">مرحله ۲</span>
              <h2 class="bnp-bill-card__title">پرداخت قبض تلفن همراه</h2>
            </div>
          </header>
          <div class="bnp-bill-card__body">
            <label for="bnpBillMobile" class="bnp-bill-label">شماره تلفن همراه خود را وارد کنید</label>
            <input id="bnpBillMobile" class="form-control bnp-bill-input required" type="text" inputmode="numeric" placeholder="09__-_______" @input="checkOperationSim" v-mask="'####-#######'" v-model="mobileNumber" dir="ltr" />
            <div class="bnp-bill-operators">
              <span class="bnp-bill-operator bnp-bill-operator--mtn" :class="{ 'is-active': operationSim == 'MTN' }"><i class="fas fa-signal" aria-hidden="true"></i> ایرانسل</span>
              <span class="bnp-bill-operator bnp-bill-operator--mci" :class="{ 'is-active': operationSim == 'MCI' }"><i class="fas fa-signal" aria-hidden="true"></i> همراه اول</span>
              <span class="bnp-bill-operator bnp-bill-operator--rightel" :class="{ 'is-active': operationSim == 'RIGHTEL' }"><i class="fas fa-signal" aria-hidden="true"></i> رایتل</span>
            </div>
            <button type="button" class="bnp-bill-btn" @click="Inquiry_Mobile">
              <i class="fas fa-search" aria-hidden="true"></i>
              استعلام جزئیات تلفن همراه
            </button>

            <div class="bnp-bill-saved" v-if="listSave && listSave.length">
              <div class="bnp-bill-saved__title"><i class="fas fa-history" aria-hidden="true"></i> قبوض ذخیره‌شده</div>
              <div class="bnp-bill-saved__item Pointer" v-for="(item, key) in listSave" :key="key" @click="ReplaceMobileSave(item)">
                <div class="bnp-bill-saved__content" :key="Render">
                  <span class="bnp-bill-saved__icon" aria-hidden="true"><i class="fas fa-mobile-alt"></i></span>
                  <div class="bnp-bill-saved__text">
                    <span class="bnp-bill-saved__name">قبض تلفن همراه</span>
                    <span class="bnp-bill-saved__code" dir="ltr">{{ item.participateCode == null ? item.billId : item.participateCode }}</span>
                  </div>
                  <button type="button" class="bnp-bill-saved__delete" title="حذف" aria-label="حذف قبض ذخیره‌شده" @click="deleteSave(item)"><i class="fas fa-trash-alt" aria-hidden="true"></i></button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- ثابت -->
        <section class="bnp-bill-card" v-if="inx == 4" id="FixedLine">
          <header class="bnp-bill-card__header">
            <span class="bnp-bill-card__icon bnp-bill-card__icon--type" aria-hidden="true"><i class="fas fa-phone-alt"></i></span>
            <div class="bnp-bill-card__heading">
              <span class="bnp-bill-card__step">مرحله ۲</span>
              <h2 class="bnp-bill-card__title">پرداخت قبض تلفن ثابت</h2>
            </div>
          </header>
          <div class="bnp-bill-card__body">
            <label for="bnpBillFixedLine" class="bnp-bill-label">شماره تلفن ثابت + کد شهر خود را وارد کنید</label>
            <input id="bnpBillFixedLine" class="form-control bnp-bill-input required" type="text" inputmode="numeric" placeholder="0__-________" v-mask="'###-########'" v-model="fixedLineNumber" dir="ltr" />
            <button type="button" class="bnp-bill-btn" @click="Inquiry_FixedLine">
              <i class="fas fa-search" aria-hidden="true"></i>
              استعلام جزئیات تلفن ثابت
            </button>

            <div class="bnp-bill-saved" v-if="listSave && listSave.length">
              <div class="bnp-bill-saved__title"><i class="fas fa-history" aria-hidden="true"></i> قبوض ذخیره‌شده</div>
              <div class="bnp-bill-saved__item Pointer" v-for="(item, key) in listSave" :key="key" @click="fixedLineNumber = item.billId">
                <div class="bnp-bill-saved__content" :key="Render">
                  <span class="bnp-bill-saved__icon" aria-hidden="true"><i class="fas fa-phone-alt"></i></span>
                  <div class="bnp-bill-saved__text">
                    <span class="bnp-bill-saved__name">قبض تلفن ثابت</span>
                    <span class="bnp-bill-saved__code" dir="ltr">{{ item.participateCode == null ? item.billId : item.participateCode }}</span>
                  </div>
                  <button type="button" class="bnp-bill-saved__delete" title="حذف" aria-label="حذف قبض ذخیره‌شده" @click="deleteSave(item)"><i class="fas fa-trash-alt" aria-hidden="true"></i></button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- مرحله ۳: جزئیات (در انتظار) -->
      <section class="bnp-bill-card bnp-bill-card--placeholder" v-if="!estelamIsSuccess">
        <div class="bnp-bill-empty">
          <span class="bnp-bill-empty__icon" aria-hidden="true"><i class="fas fa-receipt"></i></span>
          <span class="bnp-bill-card__step">مرحله ۳</span>
          <h2 class="bnp-bill-card__title">جزئیات و پرداخت</h2>
          <p class="bnp-bill-empty__text">پس از استعلام، جزئیات قبض در این بخش نمایش داده می‌شود.</p>
        </div>
      </section>

      <!-- مرحله ۳: جزئیات قبض -->
      <div class="bnp-bill-step" v-if="estelamIsSuccess">
        <!-- آب -->
        <section class="bnp-bill-card" v-if="inx == 0">
          <header class="bnp-bill-card__header">
            <span class="bnp-bill-card__icon" aria-hidden="true"><i class="fas fa-receipt"></i></span>
            <div class="bnp-bill-card__heading">
              <span class="bnp-bill-card__step">مرحله ۳</span>
              <h2 class="bnp-bill-card__title">جزئیات قبض</h2>
            </div>
          </header>
          <div class="bnp-bill-card__body">
            <dl class="bnp-bill-details">
              <div class="bnp-bill-details__row">
                <dt>شناسه قبض</dt>
                <dd dir="ltr">{{ inquiryWater.BillID }}</dd>
              </div>
              <div class="bnp-bill-details__row">
                <dt>آدرس</dt>
                <dd>{{ inquiryWater.Address }}</dd>
              </div>
              <div class="bnp-bill-details__row">
                <dt>مشخصات</dt>
                <dd>{{ inquiryWater.FullName }}</dd>
              </div>
            </dl>
            <div class="bnp-bill-amount">
              <span class="bnp-bill-amount__label">مبلغ قابل پرداخت</span>
              <strong class="bnp-bill-amount__value">{{ $Comma3ragham(inquiryWater.Amount) }} <small>ریال</small></strong>
              <span class="bnp-bill-amount__words">{{ $Mab2persianRial($Comma3ragham(inquiryWater.Amount)) }}</span>
            </div>
            <button type="button" class="bnp-bill-btn" @click="paymentWater(inquiryWater, Taahodat)">
              <i class="fas fa-credit-card" aria-hidden="true"></i>
              تایید و پرداخت قبض
            </button>
          </div>
        </section>

        <!-- برق -->
        <section class="bnp-bill-card" v-if="inx == 1">
          <header class="bnp-bill-card__header">
            <span class="bnp-bill-card__icon" aria-hidden="true"><i class="fas fa-receipt"></i></span>
            <div class="bnp-bill-card__heading">
              <span class="bnp-bill-card__step">مرحله ۳</span>
              <h2 class="bnp-bill-card__title">جزئیات قبض</h2>
            </div>
          </header>
          <div class="bnp-bill-card__body">
            <dl class="bnp-bill-details">
              <div class="bnp-bill-details__row">
                <dt>شناسه قبض</dt>
                <dd dir="ltr">{{ inquiryElectricity.BillID }}</dd>
              </div>
              <div class="bnp-bill-details__row">
                <dt>شناسه پرداخت</dt>
                <dd dir="ltr">{{ inquiryElectricity.PaymentID }}</dd>
              </div>
              <div class="bnp-bill-details__row">
                <dt>آدرس</dt>
                <dd>{{ inquiryElectricity.Address }}</dd>
              </div>
              <div class="bnp-bill-details__row">
                <dt>مشخصات</dt>
                <dd>{{ inquiryElectricity.FullName }}</dd>
              </div>
              <div class="bnp-bill-details__row">
                <dt>نوع تعرفه</dt>
                <dd>{{ inquiryElectricity.TariffType }}</dd>
              </div>
              <div class="bnp-bill-details__row">
                <dt>نوع مشترک</dt>
                <dd>{{ inquiryElectricity.CustomerType }}</dd>
              </div>
            </dl>
            <div class="bnp-bill-amount">
              <span class="bnp-bill-amount__label">مبلغ قابل پرداخت</span>
              <strong class="bnp-bill-amount__value">{{ $Comma3ragham(inquiryElectricity.Amount) }} <small>ریال</small></strong>
              <span class="bnp-bill-amount__words">{{ $Mab2persianRial($Comma3ragham(inquiryElectricity.Amount)) }}</span>
            </div>
            <button type="button" class="bnp-bill-btn" @click="paymentElectricity(inquiryElectricity, Taahodat)">
              <i class="fas fa-credit-card" aria-hidden="true"></i>
              تایید و پرداخت قبض
            </button>
          </div>
        </section>
        <!-- گاز -->
        <section class="bnp-bill-card" v-if="inx == 2">
          <header class="bnp-bill-card__header">
            <span class="bnp-bill-card__icon" aria-hidden="true"><i class="fas fa-receipt"></i></span>
            <div class="bnp-bill-card__heading">
              <span class="bnp-bill-card__step">مرحله ۳</span>
              <h2 class="bnp-bill-card__title">جزئیات قبض</h2>
            </div>
          </header>
          <div class="bnp-bill-card__body">
            <dl class="bnp-bill-details">
              <div class="bnp-bill-details__row">
                <dt>شناسه قبض</dt>
                <dd dir="ltr">{{ inquiryGas.BillID }}</dd>
              </div>
              <div class="bnp-bill-details__row">
                <dt>شناسه پرداخت</dt>
                <dd dir="ltr">{{ inquiryGas.PaymentID }}</dd>
              </div>
              <div class="bnp-bill-details__row">
                <dt>آدرس</dt>
                <dd>{{ inquiryGas.Address }}</dd>
              </div>
              <div class="bnp-bill-details__row">
                <dt>مشخصات</dt>
                <dd>{{ inquiryGas.FullName }}</dd>
              </div>
              <div class="bnp-bill-details__row">
                <dt>نوع مصرف</dt>
                <dd>{{ inquiryGas.ConsumptionType }}</dd>
              </div>
            </dl>
            <div class="bnp-bill-amount">
              <span class="bnp-bill-amount__label">مبلغ قابل پرداخت</span>
              <strong class="bnp-bill-amount__value">{{ $Comma3ragham(inquiryGas.Amount) }} <small>ریال</small></strong>
              <span class="bnp-bill-amount__words">{{ $Mab2persianRial($Comma3ragham(inquiryGas.Amount)) }}</span>
            </div>
            <button type="button" class="bnp-bill-btn" @click="paymentGas(inquiryGas, Taahodat)">
              <i class="fas fa-credit-card" aria-hidden="true"></i>
              تایید و پرداخت قبض
            </button>
          </div>
        </section>

        <!-- موبایل -->
        <section class="bnp-bill-card" v-if="inx == 3">
          <header class="bnp-bill-card__header">
            <span class="bnp-bill-card__icon" aria-hidden="true"><i class="fas fa-receipt"></i></span>
            <div class="bnp-bill-card__heading">
              <span class="bnp-bill-card__step">مرحله ۳</span>
              <h2 class="bnp-bill-card__title">جزئیات قبض</h2>
            </div>
          </header>
          <div class="bnp-bill-card__body">
            <dl class="bnp-bill-details">
              <div class="bnp-bill-details__row">
                <dt>شناسه قبض</dt>
                <dd dir="ltr">{{ inquiryMobileData.BillID }}</dd>
              </div>
              <div class="bnp-bill-details__row">
                <dt>شماره اشتراک</dt>
                <dd dir="ltr">{{ inquiryMobileData.PaymentID }}</dd>
              </div>
            </dl>
            <div class="bnp-bill-amount">
              <span class="bnp-bill-amount__label">مبلغ قابل پرداخت</span>
              <strong class="bnp-bill-amount__value">{{ $Comma3ragham(inquiryMobileData.Amount) }} <small>ریال</small></strong>
              <span class="bnp-bill-amount__words">{{ $Mab2persianRial($Comma3ragham(inquiryMobileData.Amount)) }}</span>
            </div>
            <button type="button" class="bnp-bill-btn" @click="paymentMobile(inquiryMobileData, Taahodat)">
              <i class="fas fa-credit-card" aria-hidden="true"></i>
              تایید و پرداخت قبض
            </button>
          </div>
        </section>

        <!-- ثابت -->
        <section class="bnp-bill-card" v-if="inx == 4">
          <header class="bnp-bill-card__header">
            <span class="bnp-bill-card__icon" aria-hidden="true"><i class="fas fa-receipt"></i></span>
            <div class="bnp-bill-card__heading">
              <span class="bnp-bill-card__step">مرحله ۳</span>
              <h2 class="bnp-bill-card__title">جزئیات قبض</h2>
            </div>
          </header>
          <div class="bnp-bill-card__body">
            <div class="bnp-bill-term">
              <div class="bnp-bill-term__head">
                <span class="bnp-bill-term__label"><i class="fas fa-calendar-check" aria-hidden="true"></i> پایان دوره</span>
                <strong v-if="inquiryFixedLine.FinalTerm != null" class="bnp-bill-term__value">{{ $Comma3ragham(inquiryFixedLine.FinalTerm.Amount) }} <small>ریال</small></strong>
                <span v-else class="bnp-bill-badge bnp-bill-badge--success"><i class="fas fa-check-circle" aria-hidden="true"></i> پرداخت شده</span>
              </div>
              <button v-if="inquiryFixedLine.FinalTerm != null" type="button" class="bnp-bill-btn" @click="paymentFixedLine(inquiryFixedLine.FinalTerm, Taahodat)">
                <i class="fas fa-credit-card" aria-hidden="true"></i>
                پرداخت پایان دوره
              </button>
            </div>
            <div class="bnp-bill-term">
              <div class="bnp-bill-term__head">
                <span class="bnp-bill-term__label"><i class="fas fa-calendar-alt" aria-hidden="true"></i> میان دوره</span>
                <strong class="bnp-bill-term__value">{{ $Comma3ragham(inquiryFixedLine.MidTerm.Amount) }} <small>ریال</small></strong>
              </div>
              <button type="button" class="bnp-bill-btn" @click="paymentFixedLine(inquiryFixedLine.MidTerm, Taahodat)">
                <i class="fas fa-credit-card" aria-hidden="true"></i>
                پرداخت میان دوره
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
    <loading v-if="loadingRender"></loading>
  </div>
</template>
<script>
import Loading from '../Tools/NetPa/Loading.vue'
import Ghabz from './Ghabz.vue'
import Panel from '../Tools/NetPa/Panel.vue'
export default {
  components: { Ghabz, Loading, Panel },
  data() {
    return {
      listMobile: [
        { MTN: ['0930', '0933', '0935', '0936', '0937', '0938', '0939', '0900', '0901', '0902', '0903', '0904', '0905', '0941'] },
        { MCI: ['0910', '0911', '0912', '0913', '0914', '0915', '0916', '0917', '0918', '0919', '0990', '0991', '0992', '0993', '0994'] },
        { RIGHTEL: ['0920', '0921', '0922'] },
      ],
      operationSim: '',
      inx: null,
      waterBillId: null,
      mobileNumber: null,
      fixedLineNumber: null,
      electricityBillId: null,
      gasBillId: null,
      gasParticipateCode: null,
      estelamIsSuccess: false,
      taahodatId: null,
      loadingRender: false,
      inquiryMobileData: {},
      inquiryFixedLine: {},
      inquiryWater: {},
      inquiryElectricity: {},
      inquiryGas: {},
      listTaahodat: [],
      Taahodat: {},
      isBillGas: false,
      minMandeForInquiry: 10000,
      listSave: [],
      Render: 0,
    }
  },
  props: ['indexMenu'],
  created() {
    this.inx = this.indexMenu
    this.getSelTaahodat()
  },
  mounted() {
    this.getSelTaahodat()
    // this.getBalance()
  },
  methods: {
    openGhabz(index) {
      this.inx = index
      this.estelamIsSuccess = false
      this.getSelTaahodat()
      this.getBillInfo(11 + this.inx)
    },

    Inquiry_Water() {
      if (this.$ValidForm('Water')) {
        if (this.Taahodat.ghabelBardasht <= this.minMandeForInquiry) {
          this.$mySweetDefault('عدم موجودی', 'برای استعلام نباید موجودی حساب شما کمتر از ' + this.$Comma3ragham(this.minMandeForInquiry) + ' ' + this.$GetVahedPool() + ' باشد', 'warning', 4000)
          return
        }
        this.loadingRender = true
        var DataAxios = {
          ArryfildValue: '',
          Method: 'post',
          Action: 'Bill/BillWater',
          Token: this.$session.get('TokenNetPa'),
        }
        const formData = new FormData()
        formData.append('customerCode',this.$session.get('CustCode'))
        formData.append('taahodatId', this.taahodatId)
        formData.append('waterBillId', this.waterBillId)
        formData.append('token', this.$session.get('TokenNetPa'))
        DataAxios.ArryfildValue = formData
        this.$PostFormData(DataAxios).then((res) => {
          try {
            let data = JSON.parse(res)
            if (data.Status.Code == 'Exception') {
              this.loadingRender = false
              this.$mySweetDefault('خطا', data.Status.Description, 'warning', 4000)
            }
            if (data.Status.Code == 'Success') {
              this.loadingRender = false
              this.estelamIsSuccess = true
              this.inquiryWater = data.Parameters
              this.setDebtorRecord(1300, 'هزینه استعلام قبض آب با شناسه  : ' + this.waterBillId)
              this.saveBillInfo(11, this.waterBillId, null, this.inquiryWater.FullName)
              this.getBillInfo(11)
            }
          } catch (error) {
            if (res.status == false) {
              this.loadingRender = false
              this.$mySweetDefault('خطا', res.message, 'warning', 4000)
              return
            }
          }
        })
      }
    },
    Inquiry_Electricity() {
      if (this.$ValidForm('Electrici')) {
        if (this.Taahodat.ghabelBardasht <= this.minMandeForInquiry) {
          this.$mySweetDefault('عدم موجودی', 'برای استعلام نباید موجودی حساب شما کمتر از ' + this.$Comma3ragham(this.minMandeForInquiry) + ' ' + this.$GetVahedPool() + ' باشد', 'warning', 4000)
          return
        }
        this.loadingRender = true
        var DataAxios = {
          ArryfildValue: '',
          Method: 'post',
          Action: 'Bill/BillElectricity',
          Token: this.$session.get('TokenNetPa'),
        }
        const formData = new FormData()
        formData.append('customerCode',this.$session.get('CustCode'))
        formData.append('taahodatId', this.taahodatId)
        formData.append('electricityBillId', this.electricityBillId)
        formData.append('token', this.$session.get('TokenNetPa'))
        DataAxios.ArryfildValue = formData
        this.$PostFormData(DataAxios).then((res) => {
          try {
            let data = JSON.parse(res)
            if (data.Status.Code == 'Exception') {
              this.loadingRender = false
              this.$mySweetDefault('خطا', data.Status.Description, 'warning', 4000)
            }
            if (data.Status.Code == 'Success') {
              this.loadingRender = false
              this.estelamIsSuccess = true
              this.inquiryElectricity = data.Parameters
              this.setDebtorRecord(1300, 'هزینه استعلام قبض برق با شناسه  : ' + this.electricityBillId)
              this.saveBillInfo(12, this.electricityBillId, null, this.inquiryElectricity.FullName)
              this.getBillInfo(12)
            }
          } catch (error) {
            if (res.status == false) {
              this.loadingRender = false
              this.$mySweetDefault('خطا', res.message, 'warning', 4000)
              return
            }
          }
        })
      }
    },
    Inquiry_Gas() {
      if (this.$ValidForm('Gas')) {
        if (this.Taahodat.ghabelBardasht <= this.minMandeForInquiry) {
          this.$mySweetDefault('عدم موجودی', 'برای استعلام نباید موجودی حساب شما کمتر از ' + this.$Comma3ragham(this.minMandeForInquiry) + ' ' + this.$GetVahedPool() + ' باشد', 'warning', 4000)
          return
        }
        this.loadingRender = true
        var DataAxios = {
          ArryfildValue: '',
          Method: 'post',
          Action: 'Bill/BillGas',
          Token: this.$session.get('TokenNetPa'),
        }
        const formData = new FormData()
        formData.append('customerCode',this.$session.get('CustCode'))
        formData.append('taahodatId', this.taahodatId)
        formData.append('participateCode', this.gasParticipateCode)
        formData.append('gasBillId', this.gasBillId)
        formData.append('token', this.$session.get('TokenNetPa'))
        DataAxios.ArryfildValue = formData
        this.$PostFormData(DataAxios).then((res) => {
          try {
            let data = JSON.parse(res)
            if (data.Status.Code == 'Exception') {
              this.loadingRender = false
              this.$mySweetDefault('خطا', data.Status.Description, 'warning', 4000)
            }
            if (data.Status.Code == 'Success') {
              this.loadingRender = false
              this.estelamIsSuccess = true
              this.inquiryGas = data.Parameters
              this.setDebtorRecord(1300, 'هزینه استعلام قبض گاز با شناسه  : ' + this.gasBillId + ' و کد اشتراک :: ' + this.gasParticipateCode)
              this.saveBillInfo(13, this.gasBillId, this.gasParticipateCode, this.inquiryGas.FullName)
              this.getBillInfo(13)
            }
          } catch (error) {
            if (res.status == false) {
              this.loadingRender = false
              this.$mySweetDefault('خطا', res.message, 'warning', 4000)
              return
            }
          }
        })
      }
    },
    Inquiry_Mobile() {
      if (this.$ValidForm('Mobile')) {
        if (this.Taahodat.ghabelBardasht <= this.minMandeForInquiry) {
          this.$mySweetDefault('عدم موجودی', 'برای استعلام نباید موجودی حساب شما کمتر از ' + this.$Comma3ragham(this.minMandeForInquiry) + ' ' + this.$GetVahedPool() + ' باشد', 'warning', 4000)
          return
        }
        if (this.mobileNumber.length < 12) {
          this.$mySweetDefault('خطا', 'تعداد ارقام شماره موبایل صحیح نمی باشد', 'warning', 3000)
          return
        }
        if (this.operationSim == 'MTN') {
          //   var DataAxios = {
          //     ArryfildValue: '',
          //     Method: 'post',
          //     Action: 'Bill/BillMtn',
          //     Token: this.$session.get('TokenNetPa'),
          //   }
          //   const formData = new FormData()
          //   formData.append('customerCode',this.$session.get('CustCode'))
          //   formData.append('taahodatId', 2)
          //   formData.append('mobileNumber', this.mobileNumber.replace('-', ''))
          //   formData.append('token', this.$session.get('TokenNetPa'))
          //   DataAxios.ArryfildValue = formData
          //   this.$PostFormData(DataAxios).then((res) => {
          //     console.log(JSON.parse(res))
          //     let data = JSON.parse(res)
          //     if (data.Status.Code == 'Exception') {
          //       this.$mySweetDefault('خطا', data.Status.Description, 'warning', 3000)
          //     }
          //   })
          this.$mySweetDefault('عدم پرداخت قبض', 'با عرض پوزش ، درحال حاضر فقط امکان پرداخت قبوض خطوط همراه اول دائمی و رایتل دائمی امکان پذیر می باشد', 'info', 4000)
        }
        if (this.operationSim == 'MCI') {
          this.loadingRender = true
          var DataAxios = {
            ArryfildValue: '',
            Method: 'post',
            Action: 'Bill/BillMci',
            Token: this.$session.get('TokenNetPa'),
          }
          const formData = new FormData()
          formData.append('customerCode',this.$session.get('CustCode'))
          formData.append('taahodatId', this.taahodatId)
          formData.append('mobileNumber', this.mobileNumber.replace('-', ''))
          formData.append('token', this.$session.get('TokenNetPa'))
          DataAxios.ArryfildValue = formData
          this.$PostFormData(DataAxios).then((res) => {
            try {
              let data = JSON.parse(res)
              if (data.Status.Code == 'Exception') {
                this.loadingRender = false
                this.$mySweetDefault('خطا', data.Status.Description, 'warning', 4000)
              }
              if (data.Status.Code == 'Success') {
                this.loadingRender = false
                this.estelamIsSuccess = true
                this.inquiryMobileData = data.Parameters.MidTerm
                this.setDebtorRecord(1300, 'هزینه استعلام قبض موبایل همراه اول با شناسه  : ' + this.mobileNumber.replace('-', ''))
                this.saveBillInfo(14, this.mobileNumber, null, null)
                this.getBillInfo(14)
              }
            } catch (error) {
              if (res.status == false) {
                this.loadingRender = false
                this.$mySweetDefault('خطا', res.message, 'warning', 4000)
                return
              }
            }
          })
        }
        if (this.operationSim == 'RIGHTEL') {
          this.loadingRender = true
          var DataAxios = {
            ArryfildValue: '',
            Method: 'post',
            Action: 'Bill/BillRightel',
            Token: this.$session.get('TokenNetPa'),
          }
          const formData = new FormData()
          formData.append('customerCode',this.$session.get('CustCode'))
          formData.append('taahodatId', this.taahodatId)
          formData.append('mobileNumber', this.mobileNumber.replace('-', ''))
          formData.append('token', this.$session.get('TokenNetPa'))
          DataAxios.ArryfildValue = formData
          this.$PostFormData(DataAxios).then((res) => {
            try {
              let data = JSON.parse(res)
              if (data.Status.Code == 'Exception') {
                this.loadingRender = false
                this.$mySweetDefault('خطا', data.Status.Description, 'warning', 4000)
              }
              if (data.Status.Code == 'Success') {
                this.loadingRender = false
                this.estelamIsSuccess = true
                this.inquiryMobileData = data.Parameters.MidTerm
                this.setDebtorRecord(1300, 'هزینه استعلام قبض موبایل رایتل با شناسه  : ' + this.mobileNumber.replace('-', ''))
                this.saveBillInfo(14, this.mobileNumber, null, null)
                this.getBillInfo(14)
              }
            } catch (error) {
              if (res.status == false) {
                this.loadingRender = false
                this.$mySweetDefault('خطا', res.message, 'warning', 4000)
                return
              }
            }
          })
        }
      }
    },
    Inquiry_FixedLine() {
      if (this.$ValidForm('FixedLine')) {
        if (this.Taahodat.ghabelBardasht <= this.minMandeForInquiry) {
          this.$mySweetDefault('عدم موجودی', 'برای استعلام نباید موجودی حساب شما کمتر از ' + this.$Comma3ragham(this.minMandeForInquiry) + ' ' + this.$GetVahedPool() + ' باشد', 'warning', 4000)
          return
        }
        this.loadingRender = true
        var DataAxios = {
          ArryfildValue: '',
          Method: 'post',
          Action: 'Bill/BillFixedLine',
          Token: this.$session.get('TokenNetPa'),
        }
        const formData = new FormData()
        formData.append('customerCode',this.$session.get('CustCode'))
        formData.append('taahodatId', this.taahodatId)
        formData.append('fixedLineNumber', this.fixedLineNumber.replace('-', ''))
        formData.append('token', this.$session.get('TokenNetPa'))
        DataAxios.ArryfildValue = formData
        this.$PostFormData(DataAxios).then((res) => {
          try {
            let data = JSON.parse(res)
            if (data.Status.Code == 'Exception') {
              this.loadingRender = false
              this.$mySweetDefault('خطا', data.Status.Description, 'warning', 4000)
            }
            if (data.Status.Code == 'Success') {
              this.loadingRender = false
              this.estelamIsSuccess = true
              this.inquiryFixedLine = data.Parameters
              this.setDebtorRecord(1300, 'هزینه استعلام قبض تلفن ثابت با شناسه  : ' + this.fixedLineNumber)
              this.saveBillInfo(15, this.fixedLineNumber, null, null)
              this.getBillInfo(15)
            }
          } catch (error) {
            if (res.status == false) {
              this.loadingRender = false
              this.$mySweetDefault('خطا', res.message, 'warning', 4000)
              return
            }
          }
        })
      }
    },

    checkOperationSim() {
      this.estelamIsSuccess = false
      this.operationSim = ''
      let pishSim = this.mobileNumber.split('-')[0]
      this.listMobile.forEach((op) => {
        var key = Object.keys(op)
        var find = op[key].find((x) => x == pishSim)

        if (typeof find == 'string') {
          this.operationSim = key[0]
          return
        }
      })
    },
    getSelTaahodat() {
      let DataAxiosTaahodat = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', 2)
      DataAxiosTaahodat.ArryfildValue = formData
      this.$PostFormData(DataAxiosTaahodat).then((data) => {
        this.listTaahodat = data
      })
    },

    paymentWater(Bill, Taahodat) {
      if (Taahodat.ghabelBardasht >= Bill.Amount) {
        this.setDebtorRecord(Bill.Amount, ' قبض آب با شناسه : ' + this.waterBillId).then((res) => {
          if (res == true) {
            // this.paymentBill(Bill.BillID,Bill.PaymentID,Bill.Amount)
          }
        })
      } else {
        this.$mySweetDefault('عدم موجودی کافی', 'میزان موجودی حساب انتخابی شما کمتر از مبلغ قبض میباشد', 'warning', 3000)
      }
    },
    paymentElectricity(Bill, Taahodat) {
      if (Taahodat.ghabelBardasht >= Bill.Amount) {
        this.payBillWithDebit(Bill, ' قبض برق با شناسه : ' + this.electricityBillId) // NetPa HANDOFF S14 : bardasht + pardakht samt-e server
      } else {
        this.$mySweetDefault('عدم موجودی کافی', 'میزان موجودی حساب انتخابی شما کمتر از مبلغ قبض میباشد', 'warning', 3000)
      }
    },
    paymentGas(Bill, Taahodat) {
      if (Taahodat.ghabelBardasht >= Bill.Amount) {
        this.payBillWithDebit(Bill, ' قبض گاز با شناسه : ' + this.gasBillId + ' و کد اشتراک :: ' + this.gasParticipateCode) // NetPa HANDOFF S14 : bardasht + pardakht samt-e server
      } else {
        this.$mySweetDefault('عدم موجودی کافی', 'میزان موجودی حساب انتخابی شما کمتر از مبلغ قبض میباشد', 'warning', 3000)
      }
    },
    paymentMobile(Bill, Taahodat) {
      if (Taahodat.ghabelBardasht >= Bill.Amount) {
        this.payBillWithDebit(Bill, ' قبض موبایل با شناسه : ' + this.mobileNumber.replace('-', '')) // NetPa HANDOFF S14 : bardasht + pardakht samt-e server
      } else {
        this.$mySweetDefault('عدم موجودی کافی', 'میزان موجودی حساب انتخابی شما کمتر از مبلغ قبض میباشد', 'warning', 3000)
      }
    },
    paymentFixedLine(Bill, Taahodat) {
      if (Taahodat.ghabelBardasht >= Bill.Amount) {
        this.payBillWithDebit(Bill, ' قبض تلفن ثابت با شناسه : ' + this.fixedLineNumber) // NetPa HANDOFF S14 : bardasht + pardakht samt-e server
      } else {
        this.$mySweetDefault('عدم موجودی کافی', 'میزان موجودی حساب انتخابی شما کمتر از مبلغ قبض میباشد', 'warning', 3000)
      }
    },

    // NetPa HANDOFF S14 (ghabz) : ghablan natije-ye setDebtorRecord (bardasht az hesab) nadide gerefte mishod va paymentBill dar har
    // surat seda zade mishod (EnteghalVajh captcha mikhahad => bardasht hamishe na-movafagh) : ghabz az pul-e sandugh , bedun-e
    // bardasht az ozv pardakht mishod . Hala Bill/PayWithDebit server khodesh bardasht mikonad , baad ghabz ; age ghabz na-movafagh , bardasht hazf .
    payBillWithDebit(Bill, typeBill) {
      if (!this.$OnceGuard('BillPayment', 8000)) return
      this.loadingRender = true
      let data = {
        wwwtblTaahodatId: this.Taahodat.id,
        billId: Bill.BillID + '',
        paymentId: Bill.PaymentID + '',
        amount: Number(Bill.Amount),
        billDesc: typeBill,
      }
      this.$PostData_new('Bill/PayWithDebit', 'POST', data, false).then((res) => {
        let dataParse
        try {
          dataParse = JSON.parse(res)
          this.loadingRender = false
          if (dataParse.Status.Code == 'Success') {
            this.$mySweetDefault('عملیات موفق', dataParse.Status.Description, 'success', 4000)
          } else {
            this.$mySweetDefault('خطا', dataParse.Status.Description, 'warning', 4000)
          }
        } catch (error) {
          this.loadingRender = false
          this.$mySweetDefault('خطا', res && res.message ? res.message : 'پرداخت قبض با خطا مواجه شد. قبل از تکرار، گردش حساب را بررسی کنید', 'warning', 4000)
        }
      })
    },
    setDebtorRecord(Mablagh, typeBill) {
      return new Promise((success, reject) => {
        let DataAxios = {
          ArryfildValue: '',
          Method: 'Post',
          Action: 'EnteghalVajh',
          Token: this.$session.get('TokenNetPa'),
        }
        const formData = new FormData()
        formData.append('wwwtblAzaId',this.$session.get('UserInfoNetPa').wwwtblAzaId);
        formData.append('wwwtblTaahodatIdBestanKar', 0)
        formData.append('wwwtblTaahodatIdBedehKar', this.Taahodat.id)
        formData.append('Mablagh', Mablagh)
        formData.append('Desc', ' پرداخت قبض - ' + typeBill)
        formData.append('KodRahgiri', '')
        formData.append('CardNo', '')
        formData.append('ShebaNo', '')
        formData.append('NameSahebHesab', this.Taahodat.nameFamily)
        formData.append('EnteghalNoe', 6)
        formData.append('HesabNo', '')
        formData.append('OrderId', '-2')
        formData.append('MabKarmozdEnteghal', 0)
        formData.append('MabKarmozdBnp', 0)
        formData.append('BankName', '')
        formData.append('ComboIdGrp324', '')
        formData.append('TarixSanad', this.$store.state.JalaliDate)
        formData.append('tblcombiId330NoeEnteghal', 181070513)
        DataAxios.ArryfildValue = formData
        this.$PostFormData(DataAxios).then((data) => {
          if (data.success === 'SUCCESS') {
            success(true)
          } else {
            success(false)
            this.loadingRender = false
            this.$mySweetDefaultTost('خطا', 'در ثبت تراکنش استعلام خطایی به وجود آمده', 'warning', 2000)
          }
        })
      })
    },
    paymentBill(billId, paymentId, amount) {
      let data = {
        token: this.$session.get('TokenNetPa'),
        customerCode: this.$session.get('CustCode'),
        taahodatId: this.Taahodat.bnpCashDBtblTaahodatId,
        billId: billId,
        paymentId: paymentId,
        amount: amount,
      }
      this.$PostData_new('Bill/BillPayment', 'POST', data, false).then((res) => {
        let dataParse
        let result
        try {
          dataParse = JSON.parse(res)
          if (dataParse.Status.Code == 'Success') {
            this.loadingRender = false
            this.$mySweetDefault('عملیات موفق', dataParse.Status.Description, 'success', 4000)
            return
          } else {
            this.loadingRender = false
            this.$mySweetDefault('خطا', dataParse.Status.Description, 'warning', 4000)
          }
        } catch (error) {
          if (res.status == false) {
            this.loadingRender = false
            this.$mySweetDefault('خطا', res.message, 'warning', 4000)
            return
          }
        }
      })
    },

    saveBillInfo(BillTypeGrp53, BillId, ParticipateCode, FullName) {
      let data = {
        BnpCashDBTblAzaId: this.$session.get('UserInfoNetPa').bnpCashDBtblAzaId,
        BillTypeTblComboGrp53: BillTypeGrp53,
        BillId: BillId,
        ParticipateCode: ParticipateCode,
        FullName: FullName,
      }

      this.$PostData_new('Ghobooz/SaveBill', 'POST', data, false).then((res) => {
        this.getBillInfo(BillTypeGrp53)
      })
    },
    getBillInfo(BillTypeGrp53) {
      let DataAxios = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'Ghobooz/GetBill',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('azaId', this.$session.get('UserInfoNetPa').bnpCashDBtblAzaId)
      formData.append('BillTypeTblComboGrp53', BillTypeGrp53)
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((data) => {
        // console.log('🤦🏻‍♂️ ~ file: BillPayment.vue:777 ~ data:', data)
        this.listSave = data
        // this.Render++
      })
    },
    deleteSave(item) {
      // console.log('🤦🏻‍♂️ ~ file: BillPayment.vue:783 ~ item:', item)
      let DataAxios = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'Ghobooz/DeleteBill',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('id', item.id)
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((data) => {
        if (data.status == 'Ok') {
          this.getBillInfo(item.billTypeTblComboGrp53)
        }
      })
    },
    
    replaceGasSaved(item) {
      if (item.participateCode == null) {
        this.gasBillId = item.billId
        this.isBillGas = true
      } else {
        this.gasParticipateCode = item.participateCode
        this.isBillGas = false
      }
    },
    ReplaceMobileSave(item){
      this.mobileNumber = item.billId
      this.checkOperationSim()
    },
    // getBalance() {
    //   var DataAxios = {
    //     ArryfildValue: '',
    //     Method: 'post',
    //     Action: 'Bill/GetBalance',
    //     Token: this.$session.get('TokenNetPa'),
    //   }
    //   const formData = new FormData()
    //   formData.append('customerCode',this.$session.get('CustCode'))
    //   DataAxios.ArryfildValue = formData
    //   this.$PostFormData(DataAxios).then((res) => {
    //     console.log(res)
    //   })
    // },
  },
}
</script>
<style scoped>
.bnp-bill {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-brand-blue: #287db4;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-icon-muted: #8091a3;
  --bnp-surface-subtle: #f9fbfc;
  --bnp-surface-card: #ffffff;
  --bnp-surface-accent: #edf7fb;
  --bnp-info-soft: #edf5fb;
  --bnp-border-default: #dbe5eb;
  --bnp-border-subtle: #e8eef2;
  --bnp-border-hover: #bdcbd4;
  --bnp-success: #05a895;
  --bnp-danger: #b44f46;
  --bnp-danger-surface: #fcefed;
  --bnp-radius-sm: 10px;
  --bnp-radius-md: 14px;
  --bnp-radius-lg: 20px;
  --bnp-radius-pill: 999px;
  --bnp-shadow-sm: 0 5px 18px rgba(31, 42, 79, 0.08);
  --bnp-shadow-md: 0 12px 24px rgba(41, 52, 95, 0.18);
  --bnp-focus-color: #05b8c8;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-motion-fast: 180ms;
  --bnp-motion-normal: 360ms;
  --bnp-ease-standard: cubic-bezier(0.165, 0.84, 0.44, 1);

  /* رنگ شاخص نوع قبض */
  --bill-water: #287db4;
  --bill-water-soft: #e8f3fa;
  --bill-electricity: #c48726;
  --bill-electricity-soft: #fff4df;
  --bill-gas: #cf5a2a;
  --bill-gas-soft: #fdeee6;
  --bill-mobile: #8d58a4;
  --bill-mobile-soft: #f4ecf8;
  --bill-fixed: #068997;
  --bill-fixed-soft: #e6f7f9;
  --bill-accent: var(--bnp-brand-blue);
  --bill-accent-soft: var(--bnp-info-soft);

  container: bnp-bill / inline-size;
  max-width: 1240px;
  padding-top: 4px;
  padding-bottom: 24px;
  color: var(--bnp-text-primary);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  text-align: right;
}

.bnp-bill--t0 {
  --bill-accent: var(--bill-water);
  --bill-accent-soft: var(--bill-water-soft);
}
.bnp-bill--t1 {
  --bill-accent: var(--bill-electricity);
  --bill-accent-soft: var(--bill-electricity-soft);
}
.bnp-bill--t2 {
  --bill-accent: var(--bill-gas);
  --bill-accent-soft: var(--bill-gas-soft);
}
.bnp-bill--t3 {
  --bill-accent: var(--bill-mobile);
  --bill-accent-soft: var(--bill-mobile-soft);
}
.bnp-bill--t4 {
  --bill-accent: var(--bill-fixed);
  --bill-accent-soft: var(--bill-fixed-soft);
}

/* ---------- Bill type menu (Ghabz) ---------- */
.bnp-bill-types {
  margin-bottom: 20px;
  padding: 16px;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-lg);
  background:
    radial-gradient(circle at 100% 0%, rgba(5, 184, 200, 0.08), transparent 40%),
    radial-gradient(circle at 0% 100%, rgba(141, 88, 164, 0.07), transparent 44%),
    var(--bnp-surface-card);
  box-shadow: var(--bnp-shadow-sm);
}

.bnp-bill-types >>> .ghabz-menu {
  flex: none;
  max-width: none;
  margin: 0 !important;
  padding: 0;
}

.bnp-bill-types >>> .ghabz-menu__row {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  margin: 0;
}

.bnp-bill-types >>> .ghabz-menu__row > .d-md-block {
  display: none !important;
}

.bnp-bill-types >>> .ghabz-menu__row > [id^="Ghabz"] {
  flex: none;
  width: auto;
  max-width: none;
  margin: 0 !important;
  padding: 0;
}

.bnp-bill-types >>> .cardGhabz {
  --tile-accent: var(--bill-water);
  --tile-soft: var(--bill-water-soft);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 100%;
  min-height: 116px;
  padding: 16px 8px;
  border: 1px solid var(--bnp-border-default) !important;
  border-radius: 18px;
  background: var(--bnp-surface-card) !important;
  box-shadow: none !important;
  transition:
    border-color var(--bnp-motion-fast) var(--bnp-ease-standard),
    box-shadow var(--bnp-motion-fast) var(--bnp-ease-standard),
    transform var(--bnp-motion-fast) var(--bnp-ease-standard),
    background var(--bnp-motion-fast) var(--bnp-ease-standard);
}

.bnp-bill-types >>> .cardGhabz_Electricity {
  --tile-accent: var(--bill-electricity);
  --tile-soft: var(--bill-electricity-soft);
}
.bnp-bill-types >>> .cardGhabz_Gas {
  --tile-accent: var(--bill-gas);
  --tile-soft: var(--bill-gas-soft);
}
.bnp-bill-types >>> .cardGhabz_Mobile {
  --tile-accent: var(--bill-mobile);
  --tile-soft: var(--bill-mobile-soft);
}
.bnp-bill-types >>> .cardGhabz_FixedLine {
  --tile-accent: var(--bill-fixed);
  --tile-soft: var(--bill-fixed-soft);
}

.bnp-bill-types >>> .cardGhabz img {
  display: none;
}

.bnp-bill-types >>> .cardGhabz::before {
  display: grid;
  width: 52px;
  height: 52px;
  color: var(--tile-accent);
  font-family: "Font Awesome 5 Free";
  font-size: 22px;
  font-weight: 900;
  line-height: 1;
  place-items: center;
  border-radius: 16px;
  background: var(--tile-soft);
  box-shadow: inset 0 0 0 1px rgba(19, 36, 58, 0.04);
  transition:
    color var(--bnp-motion-fast) ease,
    background var(--bnp-motion-fast) ease,
    transform var(--bnp-motion-fast) ease;
}

.bnp-bill-types >>> .cardGhabz_Water::before {
  content: "\e005";
}
.bnp-bill-types >>> .cardGhabz_Electricity::before {
  content: "\f0e7";
}
.bnp-bill-types >>> .cardGhabz_Gas::before {
  content: "\f7e4";
}
.bnp-bill-types >>> .cardGhabz_Mobile::before {
  content: "\f3cd";
}
.bnp-bill-types >>> .cardGhabz_FixedLine::before {
  content: "\f879";
}

.bnp-bill-types >>> .cardGhabz .font-weight-bold {
  margin: 0 !important;
  color: var(--bnp-text-primary) !important;
  font-size: 13px;
  font-weight: 700 !important;
  line-height: 1.6;
  text-align: center;
}

.bnp-bill-types >>> .cardGhabz:hover {
  border-color: var(--bnp-border-hover) !important;
  box-shadow: var(--bnp-shadow-sm) !important;
  transform: translateY(-2px);
}

.bnp-bill-types >>> .cardGhabz:hover::before {
  transform: scale(1.06);
}

.bnp-bill-types >>> .cardGhabz.Active0,
.bnp-bill-types >>> .cardGhabz.Active1,
.bnp-bill-types >>> .cardGhabz.Active2,
.bnp-bill-types >>> .cardGhabz.Active3,
.bnp-bill-types >>> .cardGhabz.Active4 {
  border-color: var(--tile-accent) !important;
  background: var(--tile-soft) !important;
  box-shadow: 0 0 0 3px var(--tile-soft), var(--bnp-shadow-sm) !important;
}

.bnp-bill-types >>> .cardGhabz.Active0::before,
.bnp-bill-types >>> .cardGhabz.Active1::before,
.bnp-bill-types >>> .cardGhabz.Active2::before,
.bnp-bill-types >>> .cardGhabz.Active3::before,
.bnp-bill-types >>> .cardGhabz.Active4::before {
  color: #fff;
  background: var(--tile-accent);
  box-shadow: 0 8px 18px rgba(19, 36, 58, 0.16);
}

.bnp-bill-types >>> .cardGhabz.Active0 .font-weight-bold,
.bnp-bill-types >>> .cardGhabz.Active1 .font-weight-bold,
.bnp-bill-types >>> .cardGhabz.Active2 .font-weight-bold,
.bnp-bill-types >>> .cardGhabz.Active3 .font-weight-bold,
.bnp-bill-types >>> .cardGhabz.Active4 .font-weight-bold {
  color: var(--tile-accent) !important;
  font-weight: 800 !important;
}

/* ---------- Steps layout ---------- */
.bnp-bill-steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 290px), 1fr));
  gap: 20px;
  align-items: start;
}

.bnp-bill-step {
  min-width: 0;
}

/* ---------- Card ---------- */
.bnp-bill-card {
  container: bnp-bill-card / inline-size;
  position: relative;
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-lg);
  background: var(--bnp-surface-card);
  box-shadow: var(--bnp-shadow-sm);
  animation: bnp-bill-rise var(--bnp-motion-normal) var(--bnp-ease-standard);
}

.bnp-bill-card::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  width: 3px;
  content: "";
  background: linear-gradient(180deg, var(--bnp-brand-cyan), var(--bnp-brand-indigo) 55%, var(--bnp-brand-purple));
  opacity: 0.9;
  pointer-events: none;
}

.bnp-bill-card__header {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 68px;
  padding: 14px 18px;
  border-bottom: 1px solid var(--bnp-border-subtle);
  background:
    radial-gradient(circle at 100% 0%, rgba(5, 184, 200, 0.1), transparent 42%),
    radial-gradient(circle at 0% 100%, rgba(141, 88, 164, 0.08), transparent 46%),
    linear-gradient(100deg, rgba(237, 247, 251, 0.96), rgba(255, 255, 255, 0.98) 62%);
}

.bnp-bill-card__icon {
  display: grid;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  color: var(--bnp-brand-blue);
  font-size: 16px;
  place-items: center;
  border-radius: 12px;
  background: var(--bnp-info-soft);
  box-shadow: inset 0 0 0 1px rgba(40, 125, 180, 0.1);
}

.bnp-bill-card__icon--type {
  color: #fff;
  background: var(--bill-accent);
  box-shadow: 0 8px 18px rgba(19, 36, 58, 0.14);
}

.bnp-bill-card__heading {
  min-width: 0;
}

.bnp-bill-card__step {
  display: block;
  color: var(--bnp-text-secondary);
  font-size: 11px;
  font-weight: 700;
  line-height: 1.6;
}

.bnp-bill-card__title {
  margin: 0;
  color: var(--bnp-brand-navy);
  font-family: inherit;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.6;
}

.bnp-bill-card__body {
  padding: 20px 18px;
}

/* ---------- Placeholder card ---------- */
.bnp-bill-card--placeholder {
  border-style: dashed;
  background: var(--bnp-surface-subtle);
  box-shadow: none;
}

.bnp-bill-card--placeholder::before {
  opacity: 0.35;
}

.bnp-bill-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 260px;
  padding: 32px 24px;
  text-align: center;
}

.bnp-bill-empty__icon {
  display: grid;
  width: 56px;
  height: 56px;
  margin-bottom: 14px;
  color: var(--bnp-icon-muted);
  font-size: 22px;
  place-items: center;
  border-radius: 18px;
  background: #fff;
  box-shadow: inset 0 0 0 1px var(--bnp-border-default);
}

.bnp-bill-empty .bnp-bill-card__title {
  color: var(--bnp-text-secondary);
}

.bnp-bill-empty__text {
  margin: 6px 0 0;
  color: var(--bnp-text-secondary);
  font-size: 12px;
  line-height: 1.9;
}

/* ---------- Form controls ---------- */
.bnp-bill-label {
  display: block;
  margin-bottom: 8px;
  color: var(--bnp-text-primary);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.8;
}

.bnp-bill-select,
.bnp-bill-input {
  width: 100%;
  height: 52px !important;
  color: var(--bnp-text-primary);
  font-family: inherit;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-md) !important;
  background-color: var(--bnp-surface-subtle);
  box-shadow: none;
  transition:
    border-color var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease,
    background-color var(--bnp-motion-fast) ease;
}

.bnp-bill-select {
  padding: 0 16px;
  font-size: 14px !important;
}

.bnp-bill-input {
  padding: 0 16px;
  font-size: 18px !important;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-align: center;
}

.bnp-bill-input::placeholder {
  color: #a3b1bf;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
}

.bnp-bill-input[type="number"] {
  -moz-appearance: textfield;
}

.bnp-bill-input[type="number"]::-webkit-outer-spin-button,
.bnp-bill-input[type="number"]::-webkit-inner-spin-button {
  margin: 0;
  -webkit-appearance: none;
}

.bnp-bill-select:hover,
.bnp-bill-input:hover {
  border-color: var(--bnp-border-hover);
}

.bnp-bill-select:focus,
.bnp-bill-input:focus {
  border-color: var(--bnp-focus-color);
  outline: none;
  background-color: #fff;
  box-shadow: var(--bnp-focus-ring);
}

.bnp-bill-input.wronginput {
  border-color: var(--bnp-danger) !important;
  background-color: var(--bnp-danger-surface);
}

.bnp-bill-input.wronginput:focus {
  box-shadow: 0 0 0 4px rgba(180, 79, 70, 0.16);
}

.bnp-bill-sr-only {
  position: absolute !important;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* ---------- Segmented toggle (gas) ---------- */
.bnp-bill-toggle {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  margin: 0 0 18px;
  padding: 4px;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-md);
  background: var(--bnp-surface-subtle);
  transition: box-shadow var(--bnp-motion-fast) ease;
}

.bnp-bill-toggle:focus-within {
  border-color: var(--bnp-focus-color);
  box-shadow: var(--bnp-focus-ring);
}

.bnp-bill-toggle__option {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  padding: 6px 10px;
  color: var(--bnp-text-secondary);
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border-radius: var(--bnp-radius-sm);
  transition:
    color var(--bnp-motion-fast) ease,
    background var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease;
}

.bnp-bill-toggle__option.is-active {
  color: var(--bill-accent);
  background: #fff;
  box-shadow: 0 2px 10px rgba(31, 42, 79, 0.1);
}

/* ---------- Mobile operators ---------- */
.bnp-bill-operators {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}

.bnp-bill-operator {
  --op-color: #8a6d00;
  --op-soft: #fff6d6;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 40px;
  padding: 6px 8px;
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  border: 1px solid var(--bnp-border-subtle);
  border-radius: var(--bnp-radius-pill);
  background: var(--bnp-surface-subtle);
  transition:
    color var(--bnp-motion-fast) ease,
    border-color var(--bnp-motion-fast) ease,
    background var(--bnp-motion-fast) ease;
}

.bnp-bill-operator i {
  font-size: 11px;
  opacity: 0.45;
}

.bnp-bill-operator--mci {
  --op-color: #0e7fa8;
  --op-soft: #e6f6fb;
}

.bnp-bill-operator--rightel {
  --op-color: #ad0491;
  --op-soft: #fbe9f7;
}

.bnp-bill-operator.is-active {
  color: var(--op-color);
  border-color: var(--op-color);
  background: var(--op-soft);
}

.bnp-bill-operator.is-active i {
  opacity: 1;
}

/* ---------- Buttons ---------- */
.bnp-bill-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 52px;
  margin-top: 16px;
  padding: 10px 22px;
  color: #fff;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  border: 0;
  border-radius: var(--bnp-radius-md);
  outline: none;
  cursor: pointer;
  background: linear-gradient(110deg, var(--bnp-brand-navy), var(--bnp-brand-indigo) 58%, var(--bnp-brand-purple));
  box-shadow: var(--bnp-shadow-md);
  transition:
    transform var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease;
}

.bnp-bill-btn:hover {
  transform: translateY(-2px);
}

.bnp-bill-btn:focus-visible {
  box-shadow: var(--bnp-shadow-md), var(--bnp-focus-ring);
}

.bnp-bill-btn:active {
  transform: translateY(0);
}

/* ---------- Balance / hints ---------- */
.bnp-bill-balance {
  margin-top: 18px;
}

.bnp-bill-balance__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;
  padding: 12px 14px;
  border-radius: var(--bnp-radius-md);
  background: rgba(5, 168, 149, 0.1);
}

.bnp-bill-balance__label {
  color: #047a6c;
  font-size: 13px;
  font-weight: 700;
}

.bnp-bill-balance__label i {
  margin-left: 4px;
}

.bnp-bill-balance__value {
  color: var(--bnp-text-primary);
  font-size: 16px;
  font-weight: 800;
}

.bnp-bill-balance__value small,
.bnp-bill-amount__value small,
.bnp-bill-term__value small {
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 700;
}

.bnp-bill-hint {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 16px 0 0;
  padding: 10px 12px;
  color: var(--bnp-text-secondary);
  font-size: 12px;
  line-height: 1.8;
  border-radius: 12px;
  background: var(--bnp-info-soft);
}

.bnp-bill-hint i {
  margin-top: 5px;
  color: var(--bnp-brand-blue);
}

.bnp-bill-hint--success {
  margin-top: 10px;
  color: #047a6c;
  background: rgba(5, 168, 149, 0.08);
}

.bnp-bill-hint--success i {
  color: var(--bnp-success);
}

/* ---------- Saved bills ---------- */
.bnp-bill-saved {
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid var(--bnp-border-subtle);
}

.bnp-bill-saved__title {
  margin-bottom: 10px;
  color: var(--bnp-brand-navy);
  font-size: 13px;
  font-weight: 800;
}

.bnp-bill-saved__title i {
  margin-left: 6px;
  color: var(--bnp-brand-blue);
}

.bnp-bill-saved__item + .bnp-bill-saved__item {
  margin-top: 8px;
}

.bnp-bill-saved__content {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 10px 8px 6px;
  border: 1px solid var(--bnp-border-subtle);
  border-radius: var(--bnp-radius-md);
  background: var(--bnp-surface-subtle);
  transition:
    border-color var(--bnp-motion-fast) ease,
    background var(--bnp-motion-fast) ease;
}

.bnp-bill-saved__item:hover .bnp-bill-saved__content {
  border-color: var(--bnp-border-hover);
  background: #fff;
}

.bnp-bill-saved__icon {
  display: grid;
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  color: var(--bill-accent);
  font-size: 14px;
  place-items: center;
  border-radius: 11px;
  background: var(--bill-accent-soft);
}

.bnp-bill-saved__text {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
}

.bnp-bill-saved__name {
  overflow: hidden;
  color: var(--bnp-text-primary);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.7;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.bnp-bill-saved__name small {
  margin-right: 4px;
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 400;
}

.bnp-bill-saved__code {
  overflow: hidden;
  color: var(--bnp-text-secondary);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-align: right;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.bnp-bill-saved__delete {
  display: grid;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  margin: 0;
  padding: 0;
  color: var(--bnp-icon-muted);
  font-size: 14px;
  place-items: center;
  border: 0;
  border-radius: 12px;
  outline: none;
  background: transparent;
  cursor: pointer;
  transition:
    color var(--bnp-motion-fast) ease,
    background var(--bnp-motion-fast) ease;
}

.bnp-bill-saved__delete:hover {
  color: var(--bnp-danger);
  background: var(--bnp-danger-surface);
}

.bnp-bill-saved__delete:focus-visible {
  box-shadow: var(--bnp-focus-ring);
}

/* ---------- Details ---------- */
.bnp-bill-details {
  margin: 0;
}

.bnp-bill-details__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 0;
  border-bottom: 1px dashed var(--bnp-border-default);
}

.bnp-bill-details__row:first-child {
  padding-top: 0;
}

.bnp-bill-details__row dt {
  flex: 0 0 auto;
  margin: 0;
  color: var(--bnp-text-secondary);
  font-size: 13px;
  font-weight: 400;
  line-height: 1.8;
}

.bnp-bill-details__row dd {
  min-width: 0;
  margin: 0;
  color: var(--bnp-text-primary);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.8;
  text-align: left;
  word-break: break-word;
}

.bnp-bill-amount {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  margin-top: 18px;
  padding: 16px 14px;
  text-align: center;
  border: 1px solid rgba(5, 184, 200, 0.18);
  border-radius: var(--bnp-radius-md);
  background:
    radial-gradient(circle at 100% 0%, rgba(5, 184, 200, 0.12), transparent 50%),
    radial-gradient(circle at 0% 100%, rgba(141, 88, 164, 0.1), transparent 50%),
    var(--bnp-surface-accent);
}

.bnp-bill-amount__label {
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 700;
}

.bnp-bill-amount__value {
  color: var(--bnp-brand-navy);
  font-size: 22px;
  font-size: clamp(19px, 7cqi, 24px);
  font-weight: 800;
  line-height: 1.6;
}

.bnp-bill-amount__words {
  color: var(--bnp-brand-indigo);
  font-size: 12px;
  line-height: 1.8;
}

/* ---------- Fixed-line terms ---------- */
.bnp-bill-term {
  padding: 14px;
  border: 1px solid var(--bnp-border-subtle);
  border-radius: var(--bnp-radius-md);
  background: var(--bnp-surface-subtle);
}

.bnp-bill-term + .bnp-bill-term {
  margin-top: 14px;
}

.bnp-bill-term__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;
}

.bnp-bill-term__label {
  color: var(--bnp-brand-navy);
  font-size: 14px;
  font-weight: 800;
}

.bnp-bill-term__label i {
  margin-left: 6px;
  color: var(--bill-accent);
}

.bnp-bill-term__value {
  color: var(--bnp-text-primary);
  font-size: 17px;
  font-weight: 800;
}

.bnp-bill-term .bnp-bill-btn {
  margin-top: 12px;
}

.bnp-bill-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 700;
  border-radius: var(--bnp-radius-pill);
}

.bnp-bill-badge--success {
  color: #047a6c;
  background: rgba(5, 168, 149, 0.12);
}

@keyframes bnp-bill-rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ---------- Responsive ---------- */
/*
  منوی کناری بخشی از عرض صفحه را می‌گیرد؛ پس چیدمان بر اساس عرض خود محتوا
  (container query) تنظیم می‌شود. قواعد داخل @container توسط scoped کامپایل
  نمی‌شوند، به همین دلیل با پیشوند .bnp-bill نوشته شده‌اند تا اولویت کافی داشته باشند.
  media queryهای پایین‌تر فقط پشتیبان مرورگرهای قدیمی هستند.
*/
@container bnp-bill (max-width: 939px) {
  .bnp-bill .bnp-bill-card--placeholder {
    display: none;
  }

  .bnp-bill .bnp-bill-steps {
    gap: 16px;
  }
}

@container bnp-bill (max-width: 719px) {
  .bnp-bill .bnp-bill-types {
    padding: 12px;
    border-radius: 18px;
  }

  .bnp-bill .bnp-bill-types .ghabz-menu__row {
    gap: 8px;
  }

  .bnp-bill .bnp-bill-types .cardGhabz {
    min-height: 100px;
    padding: 12px 6px;
    border-radius: 14px;
  }

  .bnp-bill .bnp-bill-types .cardGhabz::before {
    width: 44px;
    height: 44px;
    font-size: 18px;
    border-radius: 13px;
  }

  .bnp-bill .bnp-bill-types .cardGhabz .font-weight-bold {
    font-size: 12px;
  }
}

@container bnp-bill (max-width: 559px) {
  .bnp-bill .bnp-bill-steps {
    grid-template-columns: minmax(0, 1fr);
    gap: 14px;
  }

  .bnp-bill .bnp-bill-types .ghabz-menu__row {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .bnp-bill .bnp-bill-types .ghabz-menu__row > [id^="Ghabz"] {
    grid-column: span 2;
  }

  .bnp-bill .bnp-bill-types .ghabz-menu__row > #Ghabz3 {
    grid-column: 2 / span 2;
  }
}

@container bnp-bill (max-width: 359px) {
  .bnp-bill .bnp-bill-types {
    padding: 10px;
  }

  .bnp-bill .bnp-bill-types .cardGhabz {
    min-height: 90px;
    padding: 10px 4px;
  }

  .bnp-bill .bnp-bill-types .cardGhabz::before {
    width: 38px;
    height: 38px;
    font-size: 16px;
    border-radius: 12px;
  }

  .bnp-bill .bnp-bill-types .cardGhabz .font-weight-bold {
    font-size: 11px;
  }
}

/* عرض خود کارت: کارت در چیدمان سه‌ستونه باریک‌تر از موبایل هم می‌شود */
@container bnp-bill-card (max-width: 379px) {
  .bnp-bill .bnp-bill-card__header {
    min-height: 60px;
    padding: 12px 14px;
  }

  .bnp-bill .bnp-bill-card__body {
    padding: 16px 14px;
  }

  .bnp-bill .bnp-bill-details__row {
    flex-direction: column;
    gap: 2px;
  }

  .bnp-bill .bnp-bill-details__row dd {
    width: 100%;
    text-align: right;
  }

  .bnp-bill .bnp-bill-toggle__option {
    font-size: 12px;
  }
}

@container bnp-bill-card (max-width: 319px) {
  .bnp-bill .bnp-bill-operator {
    font-size: 11px;
  }

  .bnp-bill .bnp-bill-operator i {
    display: none;
  }

  .bnp-bill .bnp-bill-saved__delete {
    flex-basis: 40px;
    width: 40px;
    height: 40px;
  }
}

@media (hover: none) {
  .bnp-bill-btn:hover,
  .bnp-bill-types >>> .cardGhabz:hover {
    transform: none;
  }
}

@supports not (container-type: inline-size) {
  @media (max-width: 991px) {
    .bnp-bill-card--placeholder {
      display: none;
    }
  }

  @media (max-width: 575px) {
    .bnp-bill-types >>> .ghabz-menu__row {
      grid-template-columns: repeat(6, minmax(0, 1fr));
    }

    .bnp-bill-types >>> .ghabz-menu__row > [id^="Ghabz"] {
      grid-column: span 2;
    }

    .bnp-bill-types >>> .ghabz-menu__row > #Ghabz3 {
      grid-column: 2 / span 2;
    }

    .bnp-bill-details__row {
      flex-direction: column;
      gap: 2px;
    }

    .bnp-bill-details__row dd {
      width: 100%;
      text-align: right;
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .bnp-bill-card {
    animation: none;
  }

  .bnp-bill-btn,
  .bnp-bill-select,
  .bnp-bill-input,
  .bnp-bill-toggle,
  .bnp-bill-toggle__option,
  .bnp-bill-operator,
  .bnp-bill-saved__content,
  .bnp-bill-saved__delete,
  .bnp-bill-types >>> .cardGhabz,
  .bnp-bill-types >>> .cardGhabz::before {
    transition: none;
  }

  .bnp-bill-btn:hover,
  .bnp-bill-types >>> .cardGhabz:hover,
  .bnp-bill-types >>> .cardGhabz:hover::before {
    transform: none;
  }
}
</style>
